import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IPollQuestions, IUserAnswers } from '../../../../models/poll.model';
import { toArray } from 'lodash';
import { PollData } from '../../../../providers/poll';
import { ToastController } from 'ionic-angular';
import { IClientConfig } from '../../../../models/client.model';
import { IUser } from '../../../../models/user.model';
import { isEmpty, has } from 'lodash';
import { take } from 'rxjs/operators';
import { GamificationProvider } from '../../../../providers/gamification';
import { TranslateCodePipe } from '../../../../pipes/translate';

@Component({
  selector: 'app-poll-questions',
  templateUrl: 'poll-questions.html'
})

export class PollQuestionsComponent implements OnInit {

  @Input('clientId')
  public clientId: string;

  @Input('clientConfig')
  public clientConfig: IClientConfig;

  @Input('pollId')
  public pollId: string;

  @Input('user')
  public user: IUser;

  @Input('questions')
  public questions: IPollQuestions;

  @Input('language')
  public language: string;

  @Output('closeModal')
  public closeModal: EventEmitter<boolean> = new EventEmitter();

  public questionsPoll: any[];
  public questionIndex: number = 0;

  public userAnswerPoll: any;

  public userHasRecord: boolean = false;

  constructor(
    private pollData: PollData,
    private toastCtrl: ToastController,
    private gamificationProvider: GamificationProvider,
    private translatePipe: TranslateCodePipe
  ) { }

  ngOnInit() {
    this.getUserAnswersFromDatabase();
    this.getQuestions();
  }

  /**
   * Get the userAnswer from database by ClientId, PollId & userId
   * 1. If userAnswer exists assign the value to userAnswerPoll
   * 2. If not, assign empty value
  */
  public getUserAnswersFromDatabase() {
    this.pollData.getUserAnswer(this.clientId, this.pollId, this.user.info.id).subscribe((userAnswer: IUserAnswers) => {
      if (!isEmpty(userAnswer)) {
        this.userHasRecord = true;
        this.userAnswerPoll = userAnswer.answers;
      } else {
        this.userAnswerPoll = {}
      }
    })
  }

  /**
   * Get userAnswer
   * 1. Check if userAnswerPoll is not empty, and has the questionId attribute
   * 2. If yes, return the value of the questionId attribute
   * @param questionId
   * @author Sebastián Guevara
   */
  public getUserAnswer(questionId: string) {
    if (!isEmpty(this.userAnswerPoll) && has(this.userAnswerPoll, questionId)) {
      return this.userAnswerPoll[questionId];
    }
  }

  /**
   * Convert to array an specific object
   * @param object
   * @author Sebastián Guevara
   */
  public convertToArray(object) {
    return toArray(object);
  }

  /**
   * Asign the questions to questionsPoll
   * @author Sebastián Guevara
   */
  public getQuestions() {
    this.questionsPoll = this.convertToArray(this.questions).filter(q => q.isVisible === 'true' || !q.isVisible);
  }

  /**
   * Get the current question based on the current question index
   * @author Sebastián Guevara
   */
  public getCurrentQuestion() {
    return this.questionsPoll[this.questionIndex];
  }

  /**
   * Mofify the index of the question
   * @param operation
   * @param
   */
  public modifyIndex(operation: string, $event) {
    switch (operation) {
      case 'previous':
        if (this.questionIndex - 1 >= 0) {
          this.questionIndex -= 1;
        }
        break;
      case 'next':
        this.userAnswerPoll[$event.id] = $event.value;
        if (this.questionIndex + 1 <= this.questionsPoll.length - 1) {
          this.questionIndex += 1;
        }
        else {
          this.saveAnswer();
        }
        break;
    }
  }

  public isButtonShowing(operation: string) {
    switch (operation) {
      case 'previous':
        if (this.questionIndex === 0) {
          return false;
        } else {
          return true;
        }
      case 'next':
        if (this.questionIndex === this.questionsPoll.length - 1) {
          return false;
        }
        return true;
    }
  }

  public itLastQuestion() {
    return this.questionIndex === this.questionsPoll.length - 1
  }

  public saveAnswer() {
    if (!this.userHasRecord) {
      this.pollData.savePollAnswer(this.clientId, this.pollId,
        this.user.info.id, this.userAnswerPoll).pipe(
          take(1)
        ).subscribe(async (pollAnswer) => {
          this.gamificationProvider.applyPoints(this.clientId, this.user.info.id, 'polls');
          if (this.user.info.partnerId) this.gamificationProvider.applyPointsPartner(this.clientId, this.user.info.partnerId, this.user.info.id, 'polls');
          this.toastCtrl.create({
            message: await this.translatePipe.transform('Thanks for share your opinion'),
            duration: 3000
          }).present();
          this.closeModal.emit(true);
        })
    } else {
      this.closeModal.emit(true);
    }
  }


}


// WEBPACK FOOTER //
// ./src/pages/poll/components/poll-questions/poll-questions.ts